var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconStrikethroughLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconStrikethrough",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1388.388 1178.604c35.04 82.32 37.92 177.6 8.64 283.32-60.36 216-199.32 294.72-305.4 322.68-42.12 11.16-85.68 16.2-129.6 16.2-191.52 0-390.24-96.24-502.68-207.96l-50.88-54.6 87.84-81.72 49.2 52.8c114.72 114 339.72 205.8 515.4 159.24 110.16-29.04 184.44-109.44 220.56-238.92 22.08-79.8 21-146.52-3.48-203.88ZM758.472 137.928c226.68-61.68 498.72 45.24 639.84 177l-81.84 87.72c-116.64-108.72-350.88-196.92-526.44-148.92-106.08 28.8-177.6 103.08-212.52 220.68-74.4 250.32 135.72 335.16 418.08 420 74.64 22.44 139.2 42.48 186.36 67.8h738v120h-1920v-120h814.92c-213.24-76.92-444.6-211.92-352.44-522.12 46.92-157.68 149.28-262.2 296.04-302.16Z",
      fillRule: "evenodd"
    })));
  }
}
IconStrikethroughLine.glyphName = 'strikethrough';
IconStrikethroughLine.variant = 'Line';
IconStrikethroughLine.displayName = 'IconStrikethroughLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconStrikethroughLine.propTypes = {
  ...SVGIcon.propTypes
};
IconStrikethroughLine.allowedProps = [...SVGIcon.allowedProps];
export default IconStrikethroughLine;
export { IconStrikethroughLine };